export const Bio = {
  name: "Lim Jia Jing",
  roles: [
    "Software Developer",
    "Robotics Engineer",
    "Automation Engineer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/limjiajing123",
  resume:
    "/docs/Lim_Jia_Jing_Resume_2025.pdf",
  linkedin: "https://www.linkedin.com/in/limjiajing123",
  twitter: "",
  insta: "",
  facebook: "",
};

export const skills = [
  // {
  //   title: "Frontend",
  //   skills: [
  //     {
  //       name: "React Js",
  //       image:
  //         "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
  //     },
  //     // {
  //     //   name: "Redux",
  //     //   image:
  //     //     "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
  //     // },
  //     // {
  //     //   name: "Next Js",
  //     //   image:
  //     //     "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
  //     // },
  //     {
  //       name: "HTML",
  //       image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
  //     },
  //     {
  //       name: "CSS",
  //       image:
  //         "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
  //     },
  //     {
  //       name: "JavaScript",
  //       image:
  //         "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
  //     },
  //     // {
  //     //   name: "Bootstrap",
  //     //   image:
  //     //     "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
  //     // },
  //     // {
  //     //   name: "Material UI",
  //     //   image:
  //     //     "data:image/png;base64,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",
  //     // },
  //     // {
  //     //   name: "Flutter",
  //     //   image:
  //     //     "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
  //     // },
  //   ],
  // },
  // {
  //   title: "Backend",
  //   skills: [
  //     {
  //       name: "Node Js",
  //       image: "https://nodejs.org/static/images/logo.svg",
  //     },
  //     {
  //       name: "Express Js",
  //       image:
  //         "data:image/png;base64,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",
  //     },
  //     {
  //       name: "Graph Ql",
  //       image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
  //     },
  //     {
  //       name: "Python",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
  //     },
  //     {
  //       name: "MySQL",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
  //     },
  //     {
  //       name: "Postgresql",
  //       image: "https://www.postgresql.org/media/img/about/press/elephant.png",
  //     },
  //     {
  //       name: "MongoDB",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
  //     },
  //     {
  //       name: "Firebase",
  //       image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
  //     },
  //   ],
  // },
  // {
  //   title: "Android",
  //   skills: [
  //     {
  //       name: "Java",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //     },
  //     {
  //       name: "Kotlin",
  //       image:
  //         "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
  //     },
  //     {
  //       name: "XML",
  //       image:
  //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
  //     },
  //     {
  //       name: "Android Studio",
  //       image:
  //         "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
  //     },
  //   ],
  // },
  {
    title: "",
    skills: [
      {
        name: "Windows",
        image:
          "https://skillicons.dev/icons?i=windows",
      },
      {
        name: "Linux",
        image:
          "https://skillicons.dev/icons?i=linux",
      },
      {
        name: "Ubuntu",
        image:
          "https://skillicons.dev/icons?i=ubuntu",
      },
      {
        name: "Git",
        image:
          "https://skillicons.dev/icons?i=git",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },    
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://skillicons.dev/icons?i=postman",
      },
      {
        name: "GoLang",
        image:
          "https://skillicons.dev/icons?i=golang",
      },
      {
        name: "C",
        image:
          "https://skillicons.dev/icons?i=c",
      },
      {
        name: "C++",
        image:
          "https://skillicons.dev/icons?i=cpp",
      },
      {
        name: "Python",
        image:
          "https://skillicons.dev/icons?i=python",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://skillicons.dev/icons?i=mysql",
      },
      {
        name: "aws",
        image:
          "https://skillicons.dev/icons?i=aws",
      },
      {
        name: ".NET",
        image:
          "https://skillicons.dev/icons?i=dotnet",
      },
      {
        name: "ROS I & II",
        image:
          "https://skillicons.dev/icons?i=ros",
      },
      {
        name: "Wireshark",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/c/c6/Wireshark_icon_new.png",
      },
      {
        name: "Figma",
        image:
          "https://skillicons.dev/icons?i=figma",
      },
      {
        name: "Firebase",
        image:
          "https://skillicons.dev/icons?i=firebase",
      },
      {
        name: "Jira",
        image:
          "https://camo.githubusercontent.com/b97eaa6d1a4edc127545803f08dc9315e7e6132960e6fadc28f7d024161a97ee/68747470733a2f2f61746c61737369616e2e67616c6c65727963646e2e76736173736574732e696f2f657874656e73696f6e732f61746c61737369616e2f61746c6173636f64652f312e342e302f313535383132333132313437352f4d6963726f736f66742e56697375616c53747564696f2e53657276696365732e49636f6e732e44656661756c74",
      },
      {
        name: "Confluence",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/confluence/confluence-original.svg",
      },
      {
        name: "Tosca",
        image:
          "https://www.tricentis.com/_next/image?url=https%3A%2F%2Fbe.tricentis.com%2Fmedia-assets%2F2022%2F08%2Ftricentis-Logo.png&w=256&q=75",
      },
      {
        name: "Jenkins",
        image:
          "https://skillicons.dev/icons?i=jenkins",
      },
      {
        name: "Oracle SQL",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/sqldeveloper/sqldeveloper-original.svg",
      },
      
    ],
  },
];

export const experiences = [
  {
    id: 1,
    img: "/images/CTSH.webp",
    role: "Automation Software Engineer (Graduate Analsyt) (Banking Financial Services Division Payment Team)",
    company: "Cognizant Tech Solutions",
    date: "June 2024 - Present",
    desc: ` Automated progression, regression, smoke, sanity, system, and usability testing for critical banking applications using Tosca, ensuring consistent quality across releases.
            Conducted functional and non-functional testing on B2B and B2C platforms (iOS, Android, Web, AS400) for apps such as TMRW and UOB Infinity, using physical devices, Perfecto, Postman, Oracle SQL (for backend validation and log analysis), and SSH (PuTTY/WinSCP).
            Deployed defect-fixed builds from SIT to UAT environments using Jenkins, improving CI/CD pipeline efficiency and accelerating validation cycles in a secure banking infrastructure.
            Created and executed test cases with Zephyr for Jira, ensuring end-to-end traceability, test coverage, and alignment with Agile user stories.
            Ensured full compliance with banking processes, industry standards, and security requirements during manual and automated testing of high-stakes financial systems.
            Collaborated with developers, business analysts, and QA teams using Jira and Confluence to track defects, document processes, and improve software quality through continuous feedback loops.
            Actively participated in the SDLC Agile sprint process, with hands-on involvement across the entire STLC, including requirement analysis, test planning, execution, defect reporting, and test closure.`,
    skills: [
      "Tosca",
      "Jira",
      "Confluence",
      "HTML",
      "CSS",
      "JavaScript",
      "PuTTY",
      "WinSCP",
      "Postman",
      "Oracle SQL",
      "Jenkins",
    ],
    img2: "/images/cognizant_event_grp_photos.webp",
  },
  {
    id: 0,
    img: "/images/RRIS_Logo.webp",
    company: "Rehabilitation Research Institute of Singapore (RRIS)",
    date: "July 2023 - May 2024",
    desc: ` Project Title: Evaluating Navigation Among Crows Algorithm For Shared Control Of A Robotic Wheelchair (Grade: A)
            Survey existing autonomous navigation among crowd algorithms.
            Integration of an existing algorithm modified for shared control and evaluate its performance in simulator.
            Created and modified GUI and visualization tool in Rviz to showcase the effects of the algorithm.
            Make recommendations for the best algorithm to use for shared control amongst crowd.
            Creation of a pipeline to test shared control amongst crowd algorithms in simulator. 
            Proven that Navigation Among Crowd Algorithm considering dynamic obstacle is unnecessary.`,
    skills: [
      "ROS I/II",
      "Docker",
      "Python",
      "C++",
      "Github",
      "Windows",
      "Linux",
    ],
    doc: "https://drive.google.com/file/d/1ugUs_DtNrEL2ZHRBMkiMN1ZMMm6mPVQe/view?usp=sharing",
    img2: "/images/simulation_walkway_with_obstacle.gif",
  },
  {
    id: 0,
    img: "/images/st-engineering-logo.webp",
    role: "Robotic Software Engineering Intern",
    company: "ST Engineering",
    date: "Jan 2023 - Aug 2023",
    desc: ` Recipient of Intern @ ST Engineering Award (The Intern @ ST Engineering Award recognises the efforts and accomplishments of outstanding interns.) 
            Hands-on experience with ROS1/ROS2 navigation stack
            Modified and implemented SLAM algorithms (Cartographer, Gmapping) in ROS to process Velodyne LiDAR point clouds by using Wireshark for network validation and ensuring accurate environment mapping.
            Engineered and integrated SLAM, localization fusion algorithms, and map-route editor applications for autonomous mobile robots, including software development, deployment, and real-world demonstrations.
            Collaborated with a team to extract and process IMU data (heading, roll, pitch, yaw) for the SPYDER hull-climbing robot’s navigation system, integrating the readings with ROS 1 and ROS 2 APIs to enhance navigation accuracy. Contributed to developing and demonstrating visualizations in RViz based on IMU headings, showcasing real-time robot orientation to clients.
            Developed Go executables for a robotic management system and integrated them into Docker images to enhance service efficiency and performance. Containerized services such as GUIAPI, MySQL for data logging, FleetAPI, and health check services, configuring each container with unique static IPs under the same private Docker network for secure and reliable inter-service communication.
            Wrote software requirements, architecture, and design for various project documentation. 
            Documented process and instruction for colleagues’ future reference and implementation 
            Integrated industrial servo motor by interfacing a controller, ensuring seamless communication and control.
            Developed a comprehensive wiring diagram, meticulously planning and documenting the electrical connections for the motor system to the controller.`,
    skills: [
      "ROS I/II",
      "Docker",
      "Python",
      "C++",
      "GoLang",
      "Postman",
      "Github",
      "WireShark",
      "Windows",
      "Linux",
    ],
    doc: "https://drive.google.com/file/d/1ugUs_DtNrEL2ZHRBMkiMN1ZMMm6mPVQe/view?usp=sharing",
    img2: "/images/Interns.webp",
  },
  // {
  //   id: 2,
  //   img: "",
  //   role: " ",
  //   company: "",
  //   date: "",
  //   desc: "",
  //   doc: "",
  // },
];

export const education = [
  {
    id: 0,
    img: "https://www.logo.wine/a/logo/Nanyang_Technological_University/Nanyang_Technological_University-Logo.wine.svg",
    school: "Nanyang Technology University, Singapore",
    date: "Aug 2020 - Jun 2024",
    grade: "4.06/5.00 CGPA",
    desc: "Graduated with Honours Distinction of class 2024. Eager to know more about the world",
    degree: "Bachelor of Mechanical Engineering Specialization in Robotics and Mechatronics",
  },
  {
    id: 1,
    img: "https://www.elca.com.sg/assets/andersonjclogo.jpg",
    school: "Anderson Junior College, Singapore",
    date: "Feb 2016 - Dec 2017",
    grade: "Graduated",
    desc: "Subject combination: H2 Physics, H2 Chemistry, H2 Mathematics, H1 Economics",
    degree: "A-Level, PCME",
  },
  // {
  //   id: 2,
  //   img: "",
  //   school: "",
  //   date: "",
  //   grade: "",
  //   desc: "",
  //   degree: "",
  // },
];

export const projects = [
  {
    id: 9,
    title: "PortFolio Website",
    date: "Present",
    description:
      `Yes this page you are looking at is my portfolio website. Nothing too fancy just fundamental training for my software development skills.
      I have designed and developed this website to showcase my projects, experiences, and skills.
      Developed and deployed a React-based portfolio website with an AI chatbot using Express.js for the backend, hosted on AWS ECS.
      Designed a frontend-backend architecture, where the backend handles API calls to OpenRouter for chatbot(DeepSeek) responses.
      Built a secure AWS infrastructure with a VPC, private subnets for ECS tasks, an ALB for frontend traffic routing, and VPC endpoints for ECR image pulling without a NAT.
      Configured a NAT instance to allow backend ECS tasks to access external APIs while maintaining private network security.
      Automated CI/CD using GitHub Actions, building Docker images, pushing them to AWS ECR, and deploying via ECS.
      Optimized performance with Styled-Components, React’s component-based design, and efficient asset management.`,
    image:
      "/images/PortfolioWebsite2024.gif",
    tags: [
      "React Js",
      "HTML5",
      "CSS3",
      "JavaScript",
      "Express.js",
      "AWS",
      "Docker",
      "GitHub",
      "CI/CD",
    ],
    // category: "all",
    // github: "",
    // webapp: "",
  },
  {
    id: 0,
    title: "Final Year Project with Rehabilitation Research institute of Singapore (RRIS): Evaluating Navigation Among Crowd Algorithms For Shared Control Of A Robotic Wheelchair",
    date: "Aug 2023 - June 2024",
    description:
      ` Shared control of robotic wheelchair can help people with disability operate wheelchair safely and efficiently. 
        The objective of this project is to develop algorithms which can help robotic wheelchair navigate in the crowd in a shared control setting. 
        Surveyed existing autonomous navigation among crowd algorithms.
        Integration of an self-modified existing algorithm for shared control inhouse-system and evaluated its performance in Gazebo with Gamma simulator.
        Created and modified GUI and visualization tool in Rviz to showcase the effects of the algorithm.
        Make recommendations for the best algorithm to use for shared control amongst crowd.
        Creation of a pipeline to test shared control amongst crowd algorithms in simulator and with real wheelchair. 
        Proven that Navigation Among Crowd Algorithm considering dynamic obstacle is unnecessary.`,
    image:
      "/images/simulation_with_rds_gui.gif",
    tags: ["ROS I", "C++", "Python", "Linux", "Windows"],
    // category: "",
    // github: "",
    // webapp: "",
  },
  {
    id: 1,
    title: "Robotic Arm from scratch",
    date: "Aug 2023 - Nov 2023",
    description:
      ` Led the design of an efficient and adaptable end-effector for the robotic arm using SolidWorks. Ensured seamless integration with the robot arm for optimal performance in object retrieval tasks.
        Converted SolidWorks files to URDF format, facilitating integration with the Robot Operating System (ROS) simulation environment. Enabled accurate representation and simulation of the robotic arm for testing and validation.
        Developed and executed simulations using ROS MoveIt and Rviz to emulate diverse scenarios.
        Integrate obstacle scenarios created by the team to assess the arm's capability to navigate and retrieve objects efficiently.
        Implemented custom path trajectory planning using ROS MoveIt to enhance the robotic arm's efficiency in object retrieval by taking in consideration of spatial constraints minimising potential collisions during operation.`,
    image:
      "/images/robot_arm_setup_2_motion.webp",
    tags: [
      "ROS I",
      "C++", 
      "Python", 
      "Linux", 
      "Windows",
      "SolidWorks",
    ],
    // category: "all",
    // github: "",
    // webapp: "",
  },
  {
    id: 2,
    title: "MA4012 Design Of A Compact Autonomous Vehicle",
    date: "Aug 2023 - Nov 2023",
    description:
      ` Designed and constructed the vehicle chassis with consideration for efficient wire placement and software integration.
        Collaborated design of the ball collection and deposition mechanism, ensuring functionality and reliability.
        Designed and integrated the VEX controller to enhance edge detection, target tracking, and ball retrieval.
        Designed and collaborated on an efficient wiring layout for seamless integration of sensors, actuators, and the VEX controller.
        Won 2nd in the competition for search and retrieval of tennis ball.`,
    image:
      "/images/Final_vehicle.webp",
    tags: ["C++", "SolidWorks", "Windows"],
    // category: "web",
    // github: "",
    // webapp: "",
  },
  {
    id: 3,
    title: "Old PortFolio Website",
    date: "Aug 2023 - Oct 2024",
    description:
      `Created the website out of interest after finding out I can have a website of my own by hosting thorugh github.
       Could have spent more time to make it more responsive, interactive and beautiful but oh wells study comes first.`,
    image:
      "images/oldportfoliowebsite.gif",
    tags: ["HTML", "CSS", "JavaScript", "Github"],
    // category: "android app",
    // github: "",
    // webapp: "",
  },
  {
    id: 10,
    title: "RealTime Software for Mechatronics System. Waveform Generator in C programming Language",
    date: "Jan 2024 - May 2024",
    description:
      ` Implemented precise D/A output generation for oscilloscope display.
        Integrated keyboard input for adjusting settings and controlling waveform parameters.
        Utilized command-line arguments for initial setup and configuration.
        Supported loading arbitrary waveforms from disk for enhanced waveform versatility.
        Ensured uninterrupted output and synchronized visual and auditory cues for user feedback.
        Utilized multi-threaded processes, timers, and interrupts for real-time operation.
        Modularized code into subroutines for better maintainability and scalability.
        Implemented features such as file I/O for storing user settings and error handling for input validation.
        Demonstrated proficiency in multi-process communication, signal handling, and program shutdown in an orderly manner.`,
    image:
      "/images/waveformproj.webp",
    tags: ["C", "Linux"],
    // category: "android app",
    // github: "",
    // webapp: "",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
